import { Text } from '@public/components/UI/Typography/Text';
import clsx from 'clsx';
import { useRouter } from 'next/router';

import styles from './DraftListHeader.module.scss';

export const DraftListHeader = () => {
  const router = useRouter();
  const isNBA = router.pathname.includes('nba');
  const isTeamDraft = router.pathname.includes('[category]');
  const league = isNBA ? 'NBA' : 'NFL';

  return (
    <div
      className={clsx(styles.listHeader, { [styles.teamDraft]: isTeamDraft })}
    >
      {isTeamDraft && (
        <Text className={styles.headerItem} variant="subtitle2">
          Draft
        </Text>
      )}
      <Text
        className={clsx(styles.headerItem, { [styles.center]: isTeamDraft })}
        variant="subtitle2"
      >
        Pick
      </Text>
      <Text
        className={clsx(styles.headerItem, styles.center)}
        variant="subtitle2"
      >
        {league} Team
      </Text>

      <Text className={styles.headerItem} variant="subtitle2">
        Player
      </Text>
      <Text
        aria-label="Position"
        className={styles.headerItem}
        variant="subtitle2"
      >
        Pos
      </Text>

      <Text className={styles.headerItem} variant="subtitle2">
        Rating
      </Text>
      <Text className={styles.headerItem} variant="subtitle2">
        Hometown
      </Text>
      <Text
        aria-label="State"
        className={styles.headerItem}
        variant="subtitle2"
      >
        St
      </Text>
      <Text
        aria-label="High School"
        className={styles.headerItem}
        variant="subtitle2"
      >
        H.S.
      </Text>
    </div>
  );
};
